import React from 'react'

export default Logo => (    
    <h1>tomat.info</h1>
)